import { getValueIfObject, parseJson, snakeToNormal } from "../../helpers";
import AnalysisCard from "./analysis-card";
import useBorrowerInfo from "../../store";
import { Fragment, useState, useEffect } from "react";
import { Offcanvas } from "react-bootstrap";
import useAuthStore from "../../../../../store/authStore";
import { FaEnvelope } from "react-icons/fa6";
import EmailHistory from "../../../../../Components/EmailHistory";
import ContentLoader from "../../../../../Components/ContentLoader";
import { IoCloseCircle } from "react-icons/io5";
import { getMailHistory } from "../../../../../API";
import useGeneralStore from "../../../../../store/generalStore";

function getOrdinal(n) {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

function formatDateWithOrdinal(dateString) {
  if (!dateString) return "";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString; 
    const day = date.getDate();
    const month = date.toLocaleDateString("en-GB", { month: "short" });
    return `${getOrdinal(day)} ${month}`;
  } catch (e) {
    return dateString; 
  }
}

export default function EmailResponse() {
  const [isOpen, setIsOpen] = useState(false);
  const [showEmails, setShowEmails] = useState(false);

  const [summaryData, setSummaryData] = useState([]);
  const [isSummaryLoading, setIsSummaryLoading] = useState(false);

  const data = useBorrowerInfo((state) => state.data);
  const userData = useAuthStore((state) => state.userData);
  const customerId = useBorrowerInfo((state) => state.customerId);
  const storeIsLoading = useBorrowerInfo((state) => state.isAnalysisLoading); 
  const analysis = useBorrowerInfo((state) => state.analysis);
  const showAlert = useGeneralStore((state) => state.open_alert); 

  const toggle = () => setIsOpen((prev) => !prev);


  useEffect(() => {
    const fetchEmailSummary = async () => {
      if (isOpen && customerId) {
        setIsSummaryLoading(true);
        setSummaryData([]); 
        try {
          const res = await getMailHistory({ customer_id: customerId });

          if (res && res.summary && Array.isArray(res.summary)) {
            setSummaryData(res.summary);
          } else {
            console.log("No Email summary found or summary is not an array.");
          }
        } catch (error) {
          console.error("Failed to fetch email summary:", error);
          showAlert({ variant: "danger", msg: "Failed to fetch email summary" });
        } finally {
          setIsSummaryLoading(false);
        }
      }
    };

    fetchEmailSummary();
  }, [isOpen, customerId, showAlert]); 

  return (
    <>
      <AnalysisCard
        title="Email Response"
        isLoading={storeIsLoading} 
        tag={analysis?.email_tag}
        content={getValueIfObject(analysis?.email_disposition, "scenario_name")}
        icon={FaEnvelope}
        onClick={toggle}
        data={data}
      />

      <Offcanvas style={{ width: "28rem", paddingTop: "0.75rem" }} show={isOpen} onHide={toggle} backdropClassName="opacity-0" placement="end">
        <Offcanvas.Header>
          <Offcanvas.Title className="d-flex justify-content-between align-items-center w-100 px-2">
            <div className="fw-600 fs-4 text-black">Email </div>{" "}
            <button onClick={toggle} type="button" className="bg-white border-0">
              <IoCloseCircle fill="#999999" size={30} />
            </button>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          
          <div className="row border mx-3 my-2 p-1 rounded-1" style={{ boxShadow: "inset 0 0 10px #cbcacabd" }}>
            <a
              onClick={() => setShowEmails(false)}
              className="col-6 text-center p-2 rounded-3 fs-6"
              style={{
                background: !showEmails ? "#009EC1" : "transparent",
                color: !showEmails ? "white" : "black",
                cursor: "pointer",
                fontWeight: !showEmails ? "bold" : "500",
              }}
            >
              Summary
            </a>
            <a
              onClick={() => setShowEmails(true)}
              className="col-6 text-center p-2 rounded-3 fs-6"
              style={{
                background: showEmails ? "#009EC1" : "transparent",
                color: showEmails ? "white" : "black",
                cursor: "pointer",
                fontWeight: showEmails ? "bold" : "500",
              }}
            >
              Emails
            </a>
          </div>

          {!showEmails ? (
            <div className="h-100">
              {isSummaryLoading && (
                <div className="position-relative h-100">
                  <ContentLoader />
                </div>
              )}
              {!isSummaryLoading && summaryData.length === 0 && (
                <p className="my-5 text-center text-black">Summary Not Found</p>
              )}
              {!isSummaryLoading && summaryData.length > 0 && (
                <div className="m-3 mt-4 rounded-5 bg-body-tertiary px-2 py-3">
                  {summaryData.map((item, i) => (
                    <Fragment key={i}>
                      {!!item.scenario && (
                        <p className="text-black px-3 mb-3">
                          <strong className="fs-5 fw-bold my-2 d-inline-block">
                            {formatDateWithOrdinal(item.date)}
                          </strong>
                          <br />
                          <span className="text-black fs-6">{item.scenario}</span>
                        </p>
                      )}
                    </Fragment>
                  ))}
                </div>
              )}
            </div>
          ) : null}
          
          <EmailHistory show={showEmails} setShow={setShowEmails} customerId={customerId} showReplyButton={false} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}